import React from "react";
import { useMutation } from "react-query";

import { StoreContext } from "app/context/Store";
import Widget from "app/components/widget/Widget";
import { useGet } from "app/services/http-service";
import { GET_RECHARGE_DETAILS_BY_ID } from "app/api/ApiEndpoints";
import PageWrapper from "app/components/page-wrapper/PageWrapper";
import RechargeSummary from "app/components/recharge-summary/RechargeSummary";

function RechargePlanDetailsById(props) {
  const rechargePlanId = props?.match?.params?.id;
  const authToken = localStorage.getItem("tspAuthToken");
  const context = React.useContext(StoreContext);
  const [step, setStep] = React.useState(4);
  const { mutate: rechargeDetailsMutation, data: rechargePlanDetailsData } =
    useMutation((data) => useGet(data));

  const changeStep = (val) => {
    setStep(val);
  };

  React.useEffect(() => {
    const body = {
      url: `${GET_RECHARGE_DETAILS_BY_ID}/${rechargePlanId}`,
      token: authToken,
    };
    rechargeDetailsMutation(body);
  }, [rechargeDetailsMutation, rechargePlanId]);

  return (
    <PageWrapper title="Recharge">
      <div className="row my-4 pay-bills">
        <div className="col-md-3 col-12">
          <Widget
            step={step}
            changeStep={changeStep}
            selectedBiller={context?.state?.rechargeNumber}
          />
        </div>
        <div className="col-md-8 col-12">
          <div className="position_relative">
            <div className="widget-provider">
              <RechargeSummary
                changeStep={changeStep}
                rechargePlanDetailsData={rechargePlanDetailsData}
              />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default RechargePlanDetailsById;
